<div class="content-container">
  <div class="section lead-block center" *ngIf="!paused">
    <img src="../../../../assets/images/flags-solid.png" />
    <br /><br />
    <br /><br />
    <h1 class="heading">{{ locale.titleText }}</h1>
    <p class="normal" ngxBalanceText>
      {{ locale.firstLineText }}
    </p>
    <p class="normal" ngxBalanceText>
      {{ locale.secondLineText }}
    </p>
    <div class="input-button" (click)="seeMyResults()">
      <button class="light checked">
        {{ locale.resultsButtonText }}
        <img class="icon" src="assets/images/next-arrow.svg" alt="" />
      </button>
    </div>
  </div>
  <div class="section lead-block center" *ngIf="paused">
    <img src="../../../../assets/images/flags-solid.png" />
    <br /><br />
    <h1 class="heading">{{ locale.pausedTitleText }}</h1>
    <p class="normal" ngxBalanceText>
      {{ locale.pausedFirstLineText }}
    </p>
    <p class="normal" ngxBalanceText>
      {{ locale.pausedSecondLineText }}
    </p>
    <div class="input-button">
      <button class="checked" (click)="reload()">
        {{ locale.pausedResultsButtonText }}
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/questionnaire-complete/questionnaire-complete.component.html